interface FetchConfig {
  method: "GET" | "POST";
  signal: AbortSignal;
  headers: any;
  body?: any;
}

interface AborterType {
  [key: string]: AbortController | null;
}

const ABORTER: AborterType = {}; // make the aborter accessible

export function postData(
  url: string,
  data: any,
  method: "GET" | "POST",
  name: keyof AborterType
) {
  // cancel pending request if any
  if (ABORTER[name]) ABORTER[name].abort();
  // make our request cancellable
  ABORTER[name] = new AbortController();
  const { signal } = ABORTER[name];

  const fetchConfig: FetchConfig = {
    method,
    signal,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (data) {
    fetchConfig.body = JSON.stringify(data);
  }
  return (
    fetch(url, fetchConfig)
      // clean up
      .then((r) => {
        ABORTER[name] = null;
        return r.json();
      })
  );
}
